import { NgModule, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { CommonModule } from '@angular/common';
import { IonicModule } from '@ionic/angular';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { StatisticsPage } from './statistics.page';
import { StatisticsDesktopPage } from './desktop/statistics.desktop.page';
import { StatisticsMobilePage } from './mobile/statistics.mobile.page';
import { TranslationModule } from '@app/app-translation.module';
import { HeaderComponentModule } from '@shared/gui/structural-components/header-component/header.component.module';
import { SegmentDesktopModule } from '@beego/ngx-segment';
import { ActivityStatisticsComponentModule } from '@internal-components/statistic-components/activity-statistic-components/activity-statistics-component/activity-statistics.component.module';
import { ClientStatisticsComponentModule } from '@internal-components/statistic-components/client-statistic-components/client-statistics-component/client-statistics.component.module';
import { DigichequeStatisticsComponentModule } from '@internal-components/statistic-components/digicheque-statistic-components/digicheque-statistics-component/digicheque-statistics.component.module';
import { LoanStatisticsComponentModule } from '@internal-components/statistic-components/loan-statistic-components/loan-statistics-component/loan-statistics.component.module';
import { AttendanceStatisticsComponentModule } from '@internal-components/statistic-components/attendance-statistic-components/attendance-statistics-component/attendance-statistics.component.module';
import { AnonymousAttendanceStatisticsComponentModule } from '@internal-components/statistic-components/anonymous-attendance-statistic-components/anonymous-attendance-statistics-component/anonymous-attendance-statistics.component.module';
import { ImpactStatisticsComponentModule } from '@internal-components/statistic-components/impact-statistic-components/impact-statistics-component/impact-statistics.component.module';
import { CancellationStatisticsComponentModule } from '@internal-components/statistic-components/cancellation-statistic-components/cancellation-statistics-component/cancellation-statistics.component.module';
import { MobileBlockerComponentModule } from '@internal/gui/structural-components/mobile-blocker-component/mobile-blocker-component.module';
import { RatingStatisticsComponentModule } from '@internal-components/statistic-components/rating-statistic-components/ratings-statistics-component/rating-statistics.component.module';
@NgModule({
	imports: [
		CommonModule,
		FormsModule,
		ReactiveFormsModule,
		IonicModule,
		RouterModule.forChild([
			{
				path: '',
				component: StatisticsPage,
			},
		]),
		TranslationModule,
		HeaderComponentModule,
		SegmentDesktopModule,
		ImpactStatisticsComponentModule,
		ActivityStatisticsComponentModule,
		ClientStatisticsComponentModule,
		DigichequeStatisticsComponentModule,
		LoanStatisticsComponentModule,
		AttendanceStatisticsComponentModule,
		AnonymousAttendanceStatisticsComponentModule,
		CancellationStatisticsComponentModule,
		RatingStatisticsComponentModule,
		MobileBlockerComponentModule,
	],
	declarations: [StatisticsPage, StatisticsDesktopPage, StatisticsMobilePage],
	schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class StatisticsPageModule {}
